import { render } from "./TariffsDetail.vue?vue&type=template&id=392d9f44&scoped=true"
import script from "./TariffsDetail.vue?vue&type=script&lang=js"
export * from "./TariffsDetail.vue?vue&type=script&lang=js"

import "./TariffsDetail.vue?vue&type=style&index=0&id=392d9f44&lang=scss&scoped=true"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-392d9f44"]])

export default __exports__